// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/work_status.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/planners/v1/resources/work_status.proto.
 */
export const file_studyo_today_planners_v1_resources_work_status = /*@__PURE__*/
  fileDesc("CjRzdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL3dvcmtfc3RhdHVzLnByb3RvEiJzdHVkeW8udG9kYXkucGxhbm5lcnMudjEucmVzb3VyY2VzKncKCldvcmtTdGF0dXMSGwoXV09SS19TVEFUVVNfVU5TUEVDSUZJRUQQABIWChJXT1JLX1NUQVRVU19BQ1RJVkUQARIZChVXT1JLX1NUQVRVU19DT01QTEVURUQQAhIZChVXT1JLX1NUQVRVU19DQU5DRUxMRUQQA0IqqgInU3R1ZHlvLlRvZGF5LlBsYW5uZXJzLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM");

/**
 * Describes the enum studyo.today.planners.v1.resources.WorkStatus.
 */
export const WorkStatusSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_planners_v1_resources_work_status, 0);

/**
 * All possible states of a work.
 *
 * @generated from enum studyo.today.planners.v1.resources.WorkStatus
 */
export const WorkStatus = /*@__PURE__*/
  tsEnum(WorkStatusSchema);

